import type { LocaleService } from '@blocksuite/affine/shared/services';

export const ASK_AI_COMMAND = 'Ask AI';

export const AI_TOOL_LOCALE_KEYS = [
  'tool.open',
  'tool.doc-compose.copied',
  'tool.doc-compose.open-title',
  'tool.doc-compose.open-message',
  'tool.doc-compose.create-failed',
  'tool.doc-compose.save',
  'tool.doc-compose.copy',
  'tool.doc-compose.failed',
  'tool.code-artifact.copied',
  'tool.code-artifact.inserted',
  'tool.code-artifact.code',
  'tool.code-artifact.preview',
  'tool.code-artifact.insert',
  'tool.code-artifact.download',
  'tool.code-artifact.copy',
  'tool.code-artifact.failed',
  'tool.web-search.searching',
  'tool.web-search.complete',
  'tool.web-search.failed',
  'tool.web-crawl.reading',
  'tool.web-crawl.complete',
  'tool.web-crawl.failed',
  'tool.doc-search.searching',
  'tool.doc-search.found',
  'tool.doc-search.failed',
  'tool.semantic-search.searching',
  'tool.semantic-search.found',
  'tool.semantic-search.failed',
  'tool.doc-read.reading',
  'tool.doc-read.complete',
  'tool.doc-read.failed',
  'tool.doc-write.creating-title',
  'tool.doc-write.creating',
  'tool.doc-write.updating-title',
  'tool.doc-write.updating',
  'tool.doc-write.renaming',
  'tool.doc-write.updating-title-label',
  'tool.doc-write.created-title',
  'tool.doc-write.created',
  'tool.doc-write.updated-title',
  'tool.doc-write.updated',
  'tool.doc-write.renamed',
  'tool.doc-write.title-updated',
  'tool.doc-write.failed',
  'tool.doc-write.document',
  'tool.doc-write.document-id',
  'tool.doc-edit.copied',
  'tool.doc-edit.editing',
  'tool.doc-edit.original',
  'tool.doc-edit.modified',
  'tool.doc-edit.deleted',
  'tool.doc-edit.inserted',
  'tool.doc-edit.expand',
  'tool.doc-edit.collapse',
  'tool.doc-edit.apply',
  'tool.doc-edit.reject',
  'tool.doc-edit.accept',
  'tool.doc-edit.failed',
  'tool.section-edit.editing',
  'tool.section-edit.content',
  'tool.section-edit.copied',
  'tool.section-edit.readonly',
  'tool.section-edit.insert-below',
  'tool.section-edit.create-doc',
  'tool.section-edit.failed',
] as const;

export function translateAIText(
  locale: LocaleService | null | undefined,
  key: string,
  fallback: string,
  options?: Record<string, unknown>
) {
  if (key === 'ask-ai') {
    return ASK_AI_COMMAND;
  }

  return (
    locale?.translate(`com.affine.ai.${key}`, fallback, {
      lng: locale.language$.value,
      ...options,
    }) ?? fallback
  );
}

/**
 * A document scope can outlive the application locale that rendered it.
 * Keep its locale only while it agrees with the active application language.
 */
export function resolveAIContextLocale(
  contextLocale: LocaleService | null | undefined,
  applicationLocale: LocaleService
) {
  return contextLocale?.language$.value === applicationLocale.language$.value
    ? contextLocale
    : applicationLocale;
}

export function translateAIItemText(
  locale: LocaleService | null | undefined,
  text: string
) {
  if (text === ASK_AI_COMMAND) {
    return ASK_AI_COMMAND;
  }

  const aiItem = translateAIText(locale, `item.${text}`, text);
  if (aiItem !== text) return aiItem;

  return (
    locale?.translate(`com.affine.blocksuite.slash.item.${text}`, text, {
      lng: locale.language$.value,
    }) ?? text
  );
}

export function translateAIGroupText(
  locale: LocaleService | null | undefined,
  text: string
) {
  return translateAIText(locale, `group.${text.toLocaleLowerCase()}`, text);
}
